

<div>
    <iui-messages id="messages" #messages  class="ms-auto me-auto"></iui-messages>
</div>

<form #form="ngForm" name="form" (ngSubmit)="submit(form)">
    <div class="mt-4 mb-4">
        <div class="row">
            <div class="col-2">
                <label for="shortCode">Short Code</label>
                <input appAlphaNumOnly appScrText required placeholder="Short Code" type="text" id="shortCode"
                    class="form-control form-text" name="shortCode" #shortCode="ngModel" maxlength="{{MaxLen.ShortCode}}" 
                    [(ngModel)]="shortCodeValue" [ngClass]="{'error-input': shortCode.errors && form.submitted}" />
            </div>
            <div class="col-2" style="align-self: flex-end;">
                <button class="btn btn-primary ms-3">Search</button>
            </div>
            <div class="col-8 d-flex justify-content-end" style="align-self: flex-end;" *ngIf="shortCodeHistory?.codes?.length">
                <button type="button" class="btn btn-primary" (click)="exportExcel()">Download History Report</button>
            </div>
        </div>
        <div class="row ps-3">
            <app-error-msg [field]="shortCode" [fieldLabel]="'Short Code'" [form]="form"></app-error-msg>
        </div>
    </div>
</form>

<div class="row" *ngIf="shortCodeDisplay">
    <div class="col-12">
        <h5>{{apiMessage}}</h5>
    </div>
    <div class="col-12 mt-1 " *ngIf="shortCodeHistory?.codes?.length">
        <a href="javascript:void(0)" (click)="navigateLookup(shortCodeValue)"><span>View details about code {{shortCodeDisplay}}</span> </a>
    </div>
</div>
<div class="row mt-1 mb-4" *ngIf="shortCodeHistory && shortCodeHistory.codes">
    <div class="col-12">
        <p-table [value]="shortCodeHistory.codes" [sortOrder]="1" sortField="userName" [columns]="tableColumn" [scrollable]="true" scrollHeight="50vh">
            <ng-template pTemplate="header" let-columns>
                <tr *ngIf="shortCodeHistory?.codes?.length">
                    <ng-container *ngFor="let col of columns">
                        <th *ngIf="!col.sort">{{col.header}}</th>
                        <th *ngIf="col.sort" class="noBorder" [style.width.%]="col.width" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns" class="noBorder" [ngSwitch]="col.field">
                        <div *ngSwitchCase="'scId'">
                            <strong>{{rowData.scId}}</strong>
                        </div>
                        <div *ngSwitchCase="'term'">
                            {{rowData.term | termLength: rowData.leaseType}}
                        </div>
                       
                        <div *ngSwitchCase="'applicationDate'">
                            {{rowData.startDate || rowData.approvalDate || rowData.createTime | date:'M/d/yyyy'}}
                        </div>
                        
                        <div *ngSwitchDefault class="ellipsis">{{rowData[col.field]}}</div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td [attr.colspan]="columns.length" class="noBorder">
                        <b>There is no history.</b>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
